import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=dc092cf8&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=dc092cf8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc092cf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc092cf8')) {
      api.createRecord('dc092cf8', component.options)
    } else {
      api.reload('dc092cf8', component.options)
    }
    module.hot.accept("./CustomModal.vue?vue&type=template&id=dc092cf8&scoped=true", function () {
      api.rerender('dc092cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/CustomModal.vue"
export default component.exports